import { PropsWithChildren, ReactNode } from "react";

export type CatalogTabLayoutProps = PropsWithChildren<{
  type: CATALOG_SECTIONS_ENUM;
  onSearch: (value: string) => void;
  searchText: string;
  actions?: ReactNode;
}>;

export type CatalogSectionInfo = {
  [key in CATALOG_SECTIONS_ENUM]: {
    name: string;
    btnAddName: string;
  };
};

export enum CATALOG_SECTIONS_ENUM {
  TECHNICKS = "TechAssets", // данные по технике
  PERSONALS = "Employees", //"AppUsers", // данные по персоналу
  APPUSERS = "AppUsers", //"AppUsers", // данные по персоналу
  SZR = "Chemicals", // данные по СЗР
  FERTILISER = "Fertilisers", // данные по удобрениям
  SEEDS = "Seeds", // данные по семенам
  CROPS = "Crops", // данные по культурам
  PHENOPHASE = "PhenoPhases", // данные по сорнякам
  WEEDS = "Weeds", // данные по сорнякам
  PESTS = "Pests", // данные по вредителям
  DISEASES = "Diseases", // данные по болезням
}
